!function (angular) {
    "use strict";

var service = angular.module('service.SSE', []);

service.factory('sseService', ['$rootScope', '$http', 'halClient', 'appSettings', 'localStorageService', 'storageKeys', '$filter', function ($rootScope, $http, halClient, appSettings, localStorageService, storageKeys, $filter) {

    var sseUrl = appSettings.apiBaseUri + "/sse";
    var sse;
    var listenerCount = 0;
    var listenerScope;
    var evt = 'servicerequestupdateevent';

    function generateUUID() { // Public Domain/MIT
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    function getStoreRequestParam() {
        var store = localStorageService.get(storageKeys.storeKey);
        var storeIdRequestParam = store !== "undefined" && store !== {} && store !== null ? '&storeId=' + store.id : "";
        return {store: store, requestParam: storeIdRequestParam}
    }

    function getUserRequestParam() {
        var profile = localStorageService.get(storageKeys.profileKey);
        var usernameRequestParam = profile !== "undefined" && profile !== {} && profile !== null ? '&userName=' + profile.username : "";
        return {user: profile, requestParam: usernameRequestParam}
    }

    function getServiceProviderRequestParam() {
        var profile = localStorageService.get(storageKeys.profileKey);
        var serviceProviderRequestParam = profile !== "undefined" && profile !== {} && profile !== null ? '&serviceProviderId=' + profile.serviceProvider : "";
        return {user: profile, requestParam: serviceProviderRequestParam}
    }

    function getUniqueIdParam(id) {
        return '?uuid=' + id;
    }

    function generateId() {
        var id = localStorageService.get(storageKeys.sseKey);
        if (id === null) {
            id = generateUUID();
            localStorageService.set(storageKeys.sseKey, id);
        }
        return id;
    }

    function isAuthenticated() {
        return localStorageService.get(storageKeys.authenticationKey) == null;
    }


    return {
        subscribe: function (scope, callback) {
            var serviceProviderObj = getServiceProviderRequestParam();

            var loginType = localStorageService.get(storageKeys.loginTypeKey);
            if (listenerCount == 0) {
                if (loginType === appSettings.storeLoginType) {
                    console.log("event subscribed for store..");
                    listenerScope = $rootScope.$on(evt, callback);
                    listenerCount++;
                }
                else if (loginType === appSettings.engineerLoginType && serviceProviderObj.user != null && serviceProviderObj.user.serviceProvider !== 0) {
                    var event = evt + serviceProviderObj.user.serviceProvider;
                    console.log("event subscribed for engineer.. " + event);
                    listenerScope = $rootScope.$on(event, callback);
                    listenerCount++;
                }
            } else {
                scope.$on("$destroy", function () {
                    console.log("clean up!")
                });
            }
        },

        get: function () {
            if (typeof(EventSource) !== "undefined") {
                var id = generateId();

                var storeObj = getStoreRequestParam();

                var userObj = getUserRequestParam();

                var serviceProviderObj = getServiceProviderRequestParam()

                var uniqueIdRequestParam = getUniqueIdParam(id);

                var loginType = localStorageService.get(storageKeys.loginTypeKey);

                if (isAuthenticated() !== undefined && loginType !== null && loginType !== undefined && sse === undefined) {
                    if (loginType === appSettings.storeLoginType) {
                        sse = new EventSource(sseUrl + uniqueIdRequestParam + storeObj.requestParam + userObj.requestParam);
                        console.log("gonna create sse for store ");
                        sse.addEventListener(evt, function (e) {
                            var info=JSON.parse(e.data);
                            console.log("value from sse to " + evt + info);
                            $rootScope.$broadcast(evt, {message:info.message,time:$filter('date')(new Date(), 'dd, MMMM yyyy HH:mm:ss')});
                        }, false);
                    }
                    else if (loginType === appSettings.engineerLoginType && serviceProviderObj.user && serviceProviderObj.user.serviceProvider !== 0) {
                        sse = new EventSource(sseUrl + uniqueIdRequestParam + serviceProviderObj.requestParam + userObj.requestParam);
                        console.log("gonna create sse for engineer ");
                        if (serviceProviderObj.user !== undefined && serviceProviderObj.user.serviceProvider !== 0 ) {
                            var event = evt + serviceProviderObj.user.serviceProvider;
                            sse.addEventListener(event, function (e) {
                                var info=JSON.parse(e.data);
                                console.log("value from sse to " + event + info);
                                $rootScope.$broadcast(event, {message:info.message,time:$filter('date')(new Date(), 'dd, MMMM yyyy HH:mm:ss')});
                            }, false);
                        }
                    }

                    if(sse !== undefined && sse !== null) {
                        sse.onopen = function (e) {
                            console.log('open ' + e);
                        };

                        sse.onerror = function (e) {
                            if (e.readyState == EventSource.CLOSED) {
                                console.log('close ' + e);
                            }
                            else {
                                console.log(e);
                                sse.close();
                                sse = undefined;
                            }
                        };
                    }
                }
                else {
                    console.log("Conditions are not conducive to create sse!");
                }
            } else {
                // Sorry! No server-sent events support using sse, use the old polling system.
                console.log('SSE not supported by browser.');
            }

            return {sse: sse, type: loginType};
        },

        isSSESupported: function(){
            if (typeof(EventSource) !== "undefined")
                return true;
            return false;
        },

        getServiceProviderInfo: function () {
            var data = getServiceProviderRequestParam().user;
            return data !== null ? data.user: null;
        },

        delete: function () {
            console.log("delete sse ");
            if(listenerScope!==undefined){
                listenerScope();
            }
            sse = undefined;
            return halClient.$del(sseUrl + '/' + localStorageService.get(storageKeys.sseKey));
        }
    };

    }]);
}(angular)